import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import { getLogger, initializeAnalytics, initializeLogger } from '@chilecompra/react-kit'
import {
  REACT_APP_ENVIRONMENT,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION
} from './config/settings/environment'
import Package from '../package.json'
import storeSingleton from './config/store/store'
import theme from './config/styles/theme'
import Routing from './Routing'

initializeAnalytics({
  gaKey: REACT_APP_GOOGLE_ANALYTICS_KEY,
  gaKeySV: REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  gtmId: REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  hotjarId: REACT_APP_HOTJAR_ID,
  hotjarSV: REACT_APP_HOTJAR_SNIPPET_VERSION
})
initializeLogger({ env: REACT_APP_ENVIRONMENT === 'prod' ? 'prod' : 'dev' })

const store = storeSingleton()
const logger = getLogger('App')
const container = document.getElementById('__root')
const root = createRoot(container)

logger.info(`React v${React.version}`)
logger.info(`Inscripción de Compradores v${Package.version}`)

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <ThemeProvider theme={theme}>
        <Routing />
      </ThemeProvider>
    </ReduxProvider>
  </StrictMode>
)
